import React from "react";
import MobileMenu from "./MobileMenu";
import { useLanguage } from "../providers/LanguageProvider";
import DesktopMenu from "./DesktopMenu";
import ReviewsSection from "../sections/ReviewSection";
import Hero from "../sections/Hero";
import IntroEasy from "../sections/IntroEasy";
import ImageStrip from "../sections/ImageStrip";
import Curriculum from "../sections/Curriculum";
import About from "../sections/About";
import Audience from "../sections/Audience";
import SiteFooter from "../sections/SiteFooter";
import Contact from "../sections/Contact";
import { getMenuItems, getContactInfo, getSocialLinks } from "../config/menuConfig";
import { microphone_background_2, microphone_background_3 } from "../assets/images";


const LiadMusic = () => {
  const { translations } = useLanguage();

  const menuItems = getMenuItems(translations);
  const contactInfo = getContactInfo(translations);
  const socialLinks = getSocialLinks(translations);

  return (
    // TODO: need to use the theme color for the gradient
    <div className="bg-gradient-to-b from-gradient-light-from to-gradient-light-to overflow-hidden">
      <DesktopMenu
        menuItems={menuItems}
        contactInfo={contactInfo}
        socialLinks={socialLinks}
      />
      <MobileMenu
        menuItems={menuItems}
        contactInfo={contactInfo}
        socialLinks={socialLinks}
      />

      <Hero id="home" />
      <IntroEasy id="intro" />
      <ImageStrip image={microphone_background_2}/>
      <Curriculum id="curriculum" />
      <About id="about" />
      <Audience id="audience" />
      <ImageStrip image={microphone_background_3}/>
      <ReviewsSection id="reviews" />
      <Contact id="contact" />

      <SiteFooter translations={translations} />

    </div>
  );
};

export default LiadMusic;
